module.exports = __webpack_public_path__ + "media/app/components/CategoryNav/iconsNewDesign/121.0806921a.svg";